<div class="location-global-header">
  <div class="location-global-header-location-info">
    <div class="row"></div>
  </div>
  <nav mat-tab-nav-bar class="global-header-link-icon-container" [tabPanel]="tabPanel">
    <ng-container *ngFor="let e of navBarMenu">
      <a
        mat-tab-link
        class="tab-link"
        *ngIf="e.display"
        [routerLink]="e.link"
        routerLinkActive="on"
        #rla="routerLinkActive"
        [active]="rla.isActive"
        [ngClass]="{ 'mn-active': isActive(e) }">
        <span class="pt-2">
          <img width="32px" height="32px" class="img-fluid desktop-img" src="../../../assets/images/icons/{{ e.id }}.svg" alt="desktop image" />
          <img width="21px" height="21px" class="img-fluid mobile-img" src="../../../assets/images/icons/{{ e.id }}-white.svg" alt="mobile image" />
        </span>
        <span class="tab-label">
          {{ e.label | translate | uppercase }}
        </span>
      </a>
    </ng-container>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>
